import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { perpsV1ViewsDataProvider } from './dataProvider';

// 注册 perps-v1-views 模块的数据提供者
export function initPerpsV1ViewsDataProvider() {
  registerModuleDataProvider(Resources.perpsV1Views, perpsV1ViewsDataProvider);
}

// 自动初始化
initPerpsV1ViewsDataProvider();
